// ============================================================================
// CHINESE TRANSLATIONS - UNITY MODULE
// ============================================================================

export const unityTranslations = {
title: "产生和平的合一",
    author: "作者：Emmanuel",
    subtitle: "每个宗教都有其原因，我们的边界来自过去",
    description: "关于灵性合一和传统间和平的思考模块",
    
    nav: {
      intro: "介绍",
      religions: "宗教",
      common: "共同基础",
      humility: "谦卑"
    },

    intro: {
      emmanuelSays: "Emmanuel说：",
      ourBordersFromPast: "我们的边界来自过去",
      bordersDescription: "每个宗教都有其原因。我们的分歧不是神的旨意，而是历史、地理、文化的产物。",
      divisionWork: "通过恐惧的障碍和边界进行分裂、隔离，是我们危险过去的作为。",
      sharedHumanity: "我们出生在不同的传统中，但我们共享同一个人性。",
      
      revelationTitle: "开启眼界的启示",
      surprisedLearning: "有一天我惊讶地得知犹太人也是上帝的儿女。",
      angelMichael: "天使米迦勒是穆斯林的伟大使者。",
      jesusNames: "耶稣、尔撒、耶书亚以不同方式为人所知，即使在基督教信仰中也是如此。",
      diverseTribes: "因为存在不同的部落、不同的教会、不同的家庭。",
      sameRealities: "我们用不同的名字谈论同样的现实。这应该使我们更亲近，而不是分裂我们。",
      
      respectTitle: "尊重：谦卑的基础，和平的守护者",
      respectFoundation: "即使兄弟情谊在客观上不适用，尊重是谦卑的基础，和平的守护者。",
      understandingProcess: "理解和尊重其他宗教是一个谦卑的过程。这并不意味着放弃自己的信仰，而是接受他人也在寻求真理。",
      
      whatBindsUs: "真正联系我们的是什么",
      seekingRelation: "每个宗教都在寻求关系。每个人都在寻求和平。",
      loveOfGod: "这种联系我们所有人的关系就是上帝的爱。",
      universalLink: "爱是超越所有边界、所有语言、所有传统的普遍联系。",
      
      inclusionTitle: "包容：甚至比宗教多样性更广阔",
      vastInclusion: "宗教多样性是广阔的，但更广阔的是在上帝呼召他们的地方包容他人。",
      respectDifferences: "尊重肤色、性别的差异，包容使我们成为独特的人类，被上帝所爱。",
      jesusCommand: "耶稣说：'彼此相爱。'",
      
      communitySpirit: "打破社群主义精神",
      communityTerror: "社群主义是伪装的恶之恨的恐怖。它将信仰转化为部落身份，转化为分隔的墙，转化为伤害的武器。",
      pridePolitics: "我们的党派精神推动我们走向骄傲的政治：",
      prideQuotes: "我伤害你是对的。我对，就这样。我发动正义战争是对的。",
      watchHeart: "注意问题的核心，注意我们自己恶的根源。",
      refuseDivision: "让我们拒绝这种以上帝之名分裂人类的偏离。",
      
      freedomTitle: "要自由，就让他人自由",
      freedomOthers: "要自由，必须知道也让他人自由。",
      defendFreedom: "我的信仰自由只有在我捍卫所有人的自由时才有价值。压迫他人就是判自己为奴。",
      
      changeHeartTitle: "改变你的心：成为真正的灯笼",
      recognizeDecency: "认识到得体对每个人来说并不相同。",
      changeYourself: "首先改变自己，逐步改变。改变你的心，改变你的生活，成为真正的灯笼。",
      beExample: "你不会在草坪上撒尿，因为它会死亡...不要把你的规则强加给别人，而是通过你的转变成为活生生的榜样。",
      
      childrenPeaceTitle: "我们的孩子将在多样性中和平生活",
      avoidPursuit: "避免逐字逐句的追究。",
      peaceChoice: "如果我们今天选择尊重，我们未来的孩子将在多样性中和平生活。和平从我们开始，现在，在我们的言行中。",
      
      discernTitle: "辨别：人还是上帝？",
      manSpeaks: "太多时候，是人的心在说话并分裂。",
      seeFruits: "从言语的果实中可以看出：盗窃、破坏、战争。小心操纵言语以竞争自己的骄傲。",
      
      lookPeaceTitle: "看向和平与爱",
      lookPeaceAll: "看向所有人的和平，看向上帝对他人的爱。",
      godSpeaks: "当言语产生和平、和解、合一时：是上帝在说话。当它们产生分裂、仇恨、战争时：是人的骄傲。",
      
      watchWordsTitle: "警惕我们的言语",
      watchShares: "警惕我们的分享，警惕我们对他人有害的相反言语。",
      disqualify: "这些恶行使我们自己失去资格。我们言语的果实揭示谁在我们里面说话：上帝还是我们自己的骄傲？",
      
      wisdomMaturityTitle: "面对我们本性的智慧和成熟",
      useScriptures: "使用经文（律法）来伤害是我们的习惯，一个几乎自然和狡猾的过程。",
      hateSin: "面对我们的罪性，我们憎恨恶和作恶的人。",
      separateActs: "但通过智慧和成熟，必须将行为与我们人类的贫困分开。",
      compassionNature: "认识到我们需要怜悯和恩典的动物本性，同时根据情况保护自己。",
      
      denounceLeadersTitle: "谴责腐败的灵性领袖",
      watchLeaders: "小心那些试图保守其堕落和不诚实秘密的灵性领袖或领导人。",
      noJustice: "没有正义，就没有榜样。没有知识，其他受害者会因我们的沉默而灭亡。",
      silenceComplicity: "面对不公正的沉默是共谋。必须说出真相以保护他人。"
    },

    religions: {
      title: "不同的宗教，一个人类",
      intro: "基督徒、穆斯林、犹太人、印度教徒、佛教徒...还有许多其他人：所有人都在寻求真理",
      theirGod: "他们的神：",
      theGood: "善：",
      theEvil: "恶：",
      theAngels: "天使：",
      theUnity: "合一：",
      values: "价值观：",
    commonGoal: "共同目标",
    seekingPeace: "所有宗教都有一个共同的目标：寻求和平、促进爱心、建设更美好的世界。超越我们的差异，我们都团结在这个追求智慧与和谐的旅程中。",
      
      christianity: {
        name: "基督教",
        godText: "独一真神，创造之父",
        goodText: "爱邻舍、宽恕、和平",
        evilText: "仇恨、自私、暴力",
        angelsText: "上帝的使者（加百列、米迦勒...）",
        unityText: "所有人的独一上帝",
        values: "爱,宽恕,和平,谦卑,正义"
      },
      islam: {
        name: "伊斯兰教",
        godText: "真主，独一且仁慈",
        goodText: "正义、慈善、和平",
        evilText: "压迫、谎言、分裂",
        angelsText: "光明天使（吉卜利勒、米卡伊勒...）",
        unityText: "万物非主唯有真主",
        values: "和平,正义,慈善,尊重,仁慈"
      },
      judaism: {
        name: "犹太教",
        godText: "耶和华，独一永恒",
        goodText: "正义、怜悯、生命",
        evilText: "压迫、诽谤、仇恨",
        angelsText: "天上的使者（玛拉基姆）",
        unityText: "以色列啊，听，耶和华是独一",
        values: "正义,生命,记忆,和平,学习"
      },
      hinduism: {
        name: "印度教",
        godText: "梵天，至高实相",
        goodText: "非暴力（不杀生）、正义之责",
        evilText: "暴力、灵性无知",
        angelsText: "天神，仁慈的天界存在",
        unityText: "一切在梵天中为一",
        values: "非暴力,真理,慈悲,纯洁,和谐"
      },
      buddhism: {
        name: "佛教",
        godText: "没有创造神，但尊重神圣",
        goodText: "慈悲、智慧、和平",
        evilText: "由无明引起的痛苦",
        angelsText: "菩萨，开悟的存在",
        unityText: "每个人都有佛性",
        values: "慈悲,智慧,和平,非暴力,觉醒"
      }
    },

    common: {
      title: "共同基础",
      intro: "善、恶、天使、独一上帝、关系、包容：联合人类的东西",
      
      goodTitle: "善",
      goodDescription: "所有宗教都教导爱、正义和慈悲",
      goodExamples: "爱邻舍如同自己|不分彼此地行善|保护弱者和受压迫者|以仁慈说真话|分享所拥有的",
      
      evilTitle: "恶",
      evilDescription: "所有宗教都谴责暴力、谎言和压迫",
      evilExamples: "无正义地杀害|偷窃和剥削|说谎和诽谤|藐视和羞辱|分裂和仇恨",
      
      angelsTitle: "天使和灵性存在",
      angelsDescription: "几乎所有宗教都承认仁慈的天界使者",
      angelsExamples: "上帝的天使使者|灵性向导|光明存在|天界保护者|菩萨和天神",
      
      godTitle: "独一上帝（或至高实相）",
      godDescription: "大多数相信独一源头，一个创造者或终极实相",
      godExamples: "基督教、伊斯兰教、犹太教：独一上帝|印度教：梵天，至高的一|佛教：普遍佛性|所有人都在寻求终极真理|所有人都渴望合一与和平",
      
      relationTitle: "关系与和平",
      relationDescription: "真正联合所有宗教和所有人的东西",
      relationExamples: "每个宗教都寻求与神圣的关系|每个人都寻求和平|这种联系我们所有人的关系就是上帝的爱|爱是普遍的联系|和平是我们共同的愿望",
      
      inclusionTitle: "包容：被上帝所爱",
      inclusionDescription: "宗教多样性是广阔的，但更广阔的是包容",
      inclusionExamples: "在上帝呼召他们的地方包容他人|尊重肤色的差异|尊重性别的差异|包容使我们成为独特的人类，被上帝所爱|耶稣说：'彼此相爱'",
      
      finalQuote: "有一天我惊讶地得知犹太人也是上帝的儿女，天使米迦勒是穆斯林的伟大使者，耶稣、尔撒、耶书亚以不同方式为人所知，即使在基督教信仰中也是如此。因为存在不同的部落、不同的教会、不同的家庭。",
      finalQuote2: "我们用不同的名字谈论同样的现实。",
      quoteAuthor: "Emmanuel，产生和平的合一"
    },

    humility: {
      title: "通向谦卑与和平的7步",
      intro: "克服社群主义并成为真正灯笼的过程",
      
      step: "步骤",
      action: "行动：",
      
      step1Title: "认识到：我们的边界来自过去",
      step1Description: "通过恐惧的障碍和边界进行分裂、隔离，是我们危险过去的作为。我们的分歧不是上帝的旨意。",
      step1Action: "接受我的传统只属于我，我是上帝所愿多样性的一部分",
      
      step2Title: "尊重：谦卑的基础，和平的守护者",
      step2Description: "即使兄弟情谊在客观上不适用，尊重是基础。",
      step2Action: "尊重所有信仰，即使不理解一切",
      
      step3Title: "理解而不评判",
      step3Description: "今天，理解他人是一个必要的谦卑过程。",
      step3Action: "真正倾听他人的信仰，不加评判",
      
      step4Title: "首先改变自己：成为真正的灯笼",
      step4Description: "认识到得体对每个人来说并不相同。逐步改变你的心，改变你的生活，成为真正的光。",
      step4Action: "不要把我的规则强加给别人，而是通过我的转变成为活生生的榜样",
      
      step5Title: "打破社群主义精神",
      step5Description: "我们的党派精神推动我们走向骄傲的政治：'我伤害你是对的，我对，就这样。'注意问题的核心，注意我们自己恶的根源。",
      step5Action: "拒绝我自己社群中的分裂言论",
      
      step6Title: "要自由，就让他人自由",
      step6Description: "我的自由取决于我给予他人的自由。",
      step6Action: "捍卫所有人的良心自由，不仅仅是我的",
      
      step7Title: "避免逐字逐句的追究",
      step7Description: "不要以恨报恨，以辱报辱。",
      step7Action: "选择和平，让我们的孩子在多样性中和平生活",
      
      discernFruits: "从果实中辨别",
      humanHeart: "分裂的人心",
      lookGodLove: "看向上帝的爱",
      watchOurWords: "警惕我们的言语",
      
      prideFruits: "人类骄傲的果实",
      prideFruitsList: "党派精神：\\\"我是对的，就这样\\\"|骄傲政治：\\\"我有理由伤害你\\\"|利用经文伤害他人（恶作剧过程）|憎恨人（而不仅仅是行为）|隐藏偏离和不诚实的属灵领袖|面对不公正保持同谋沉默|分裂与战争|伪装成虔诚的仇恨|偷窃与破坏|为骄傲而操纵|轻蔑与暴力",
      
      godFruits: "上帝之爱的果实",
      godFruitsList: "用智慧将行为与人分开|对我们人类贫困的同情|在保护自己的同时根据情况施恩|揭露不公正以保护他人|勇敢地说出真相|所有人的和平|无差别的爱|和解与团结|谦卑与尊重|所有人的自由",
      
      finalQuote: "即使兄弟情谊在客观上不适用，尊重是谦卑的基础，和平的守护者。避免逐字逐句的追究，我们未来的孩子将在多样性中和平生活。",
      author: "Emmanuel"
    },

    footer: {
      quote: "尊重是谦卑的基础，和平的守护者。如果我们今天选择尊重，我们的孩子将在多样性中和平生活。",
      author: "Emmanuel，产生和平的合一"
    }
};

export default unityTranslations;
